import React from 'react';
import { useNavigate } from '@reach/router';
import { FormattedMessage } from 'react-intl';
import { Redux, Slices } from 'spwa-ui-library';
import { StarIcon } from '../../Icons';
import classnames from 'classnames';
import css from './index.module.scss';
const { useDispatch } = Redux;
const { setStatus, setDetailsFetched } = Slices.productSlice;

export default function MediaGridListDesktop({ className, media, targetPath }) {
  const dispatch = useDispatch();
  // todo: will remove this code non use code
  // const imgBaseUrl = useSelector(selectHomeBaseURL);
  const navigate = useNavigate();
  const handleClick = (e) => {
    e.preventDefault();
    navigate(targetPath);
    dispatch(setStatus('loading'));
    dispatch(setDetailsFetched(true));
  };

  return (
    targetPath && (
      <div className={css.wrapper}>
      <a href={targetPath} className={classnames(css.root, className)} onClick={handleClick}>
        <div className={css.thumb}>
          <img className={css.img} src={`${media.mediaUrl}`} alt={media.title} />
        </div>
        <div className={css.headingTitleContainer}>
          {media?.ribbonUrl ? (
            <>
              <img className={css.ribbon} src={`${media.ribbonUrl}`} alt="" />
              <div className={css.headingTitle}>{media.title}</div>
            </> ) : (
            <div className={css.onlyheadingTitle}>{media.title}</div>
          )}
        </div>
      </a>
      </div>
    )
  );
}
